// @module DC.QuantityPricing.QtyPrice
define("DC.QuantityPricing.QtyPrice.View", [
  "dc_quantitypricing_qtyprice.tpl",
  "DC.Confirmation.View",
  "Backbone",
  "ProductDetails.Options.Selector.View",
  "Backbone.CollectionView",
  "ProductViews.Option.View",
  "Configuration",
  "GlobalViews.Message.View",
  "Utils",
  "Cart.AddToCart.Button.View",
  "Product.Model"
], function (
  dc_quantitypricing_qtyprice_tpl,
  DCConfirmationView,
  Backbone,
  ProductDetailsOptionsSelectorView,
  BackboneCollectionView,
  ProductViewsOptionView,
  Configuration,
  GlobalViewsMessageView,
  Utils,
  CartAddToCartButtonView,
  ProductModel
) {
  "use strict";

  // @class DC.QuantityPricing.QtyPrice.View @extends Backbone.View
  return Backbone.View.extend({
    template: dc_quantitypricing_qtyprice_tpl,

    initialize: function (options) {
      console.log("=== QtyPriceView INIT ===");
      console.log("context:", this.context);
      console.log("selectedIndex:", this.selectedIndex);
      console.log("combinedPriceSchedule:", this.combinedPriceSchedule);
      console.log("first tier quantity:", this.combinedPriceSchedule && this.combinedPriceSchedule[0] ? this.combinedPriceSchedule[0].minimumquantity : "NONE");
      console.log("model quantity:", this.model.get("quantity"));

      console.log("options.model.get('item')", options.model);
      this.context = options.context;
      console.log("options", options);
      this.container = options.container;
      this.application = options.container.layout.application;
      this.model = options.model;
      this.item =
        this.context === "PDP"
          ? options.model.get("item")
          : options.model.get("item");
      this.selectedIndex = 0;
      this.model.set("selectedIndex", 0);
      this.model.on("change", function() {

          console.log("=== MODEL CHANGE DEBUG ===");
          console.log("context:", this.context);
          console.log("changed attributes:", Object.keys(this.model.changed));
          this.render();
      }, this);      

      console.log("Item: ", this.item);
      this.generateViewBindings();

      // Load price levels from custom fields
      this.loadPriceLevels();
      this.model.set("combinedPriceSchedule", this.combinedPriceSchedule);
      if (this.combinedPriceSchedule && this.combinedPriceSchedule[0]) {
          this.model.set("quantity", this.combinedPriceSchedule[0].minimumquantity);
      }

      console.log("=== INIT FINAL STATE ===");
      console.log("context:", this.context);
      console.log("selectedIndex:", this.selectedIndex);
      console.log("first tier minimumquantity:", this.combinedPriceSchedule && this.combinedPriceSchedule[0] ? this.combinedPriceSchedule[0].minimumquantity : "NONE");
      console.log("model quantity:", this.model.get("quantity"));
      console.log("item _minimumQuantity:", this.item.get("_minimumQuantity", true));

      console.log("=== MATRIX DEBUG ===");
      console.log("item _matrixChilds:", this.item.get("_matrixChilds"));
      console.log("item _isMatrixParent:", this.item.get("_isMatrixParent"));
      console.log("item itemtype:", this.item.get("itemtype"));
      console.log("item _url:", this.item.get("_url"));

      console.log("=== MATRIX DEBUG 2 ===");
      console.log("item _matrixParentId:", this.item.get("_matrixParentId"));
      console.log("item matrixchilditems_detail:", this.item.get("matrixchilditems_detail"));
      console.log("item _optionsDetails:", this.item.get("_optionsDetails"));
      console.log("item itemoptions_detail:", this.item.get("itemoptions_detail"));
      console.log("item _isPurchasable:", this.item.get("_isPurchasable"));

      console.log("=== MATRIX DEBUG 3 ===");
      var optionsDetails = this.item.get("itemoptions_detail");
      if (optionsDetails && optionsDetails.fields) {
          _.each(optionsDetails.fields, function(field) {
              console.log("option:", field.label, "| mandatory:", field.ismandatory, "| type:", field.type, "| sourcefrom:", field.sourcefrom);
          });
      }

      console.log("=== CONTEXT CHECK ===");
      console.log("context:", this.context);

    }, // Add these functions to your view
    parsePriceTiers: function (tiersString) {
      if (!tiersString) return [];

      var tiers = [];
      var tierPairs = tiersString.split("|");

      _.each(tierPairs, function (pair, index) {
        var parts = pair.split(":");
        if (parts.length === 3) {
          // Changed from 2 to 3
          var qty = parseInt(parts[0], 10);
          var unitPrice = parseFloat(parts[1]);
          var totalPrice = parseFloat(parts[2]); // Added total price

          // Create the tier object
          var tier = {
            minimumquantity: qty,
            price: unitPrice, // Unit price
            totalPrice: totalPrice, // Added total price field
          };

          // Calculate maximum quantity based on the next tier's minimum quantity
          if (index < tierPairs.length - 1) {
            var nextParts = tierPairs[index + 1].split(":");
            if (nextParts.length === 3) {
              // Changed from 2 to 3
              var nextMinQty = parseInt(nextParts[0], 10);
              tier.maximumquantity = nextMinQty;
            }
          }

          tiers.push(tier);
        }
      });

      // Sort by quantity
      return _.sortBy(tiers, function (tier) {
        return tier.minimumquantity;
      });
    },

    loadPriceLevels: function () {
      var baseTiersString = this.item.get("custitem_base_price_tiers");
      var saleTiersString = this.item.get("custitem_sale_price_tiers");

      // Log raw values for debugging
      console.log("Base price tiers string:", baseTiersString);
      console.log("Sale price tiers string:", saleTiersString);

      this.priceLevels = {
        base: {
          priceschedule: this.parsePriceTiers(baseTiersString),
        },
        sale: {
          priceschedule: this.parsePriceTiers(saleTiersString),
        },
      };

      // Log parsed price levels
      console.log("Parsed price levels:", this.priceLevels);

      // Build combined price schedule
      this.combinedPriceSchedule = this.buildCombinedPriceSchedule();
    },
    // Build a combined price schedule with both base and sale prices
    buildCombinedPriceSchedule: function () {
      var self = this;
      var combinedSchedule = [];

      // Get base and sale price schedules
      var baseSchedule = this.priceLevels.base.priceschedule || [];
      var saleSchedule = this.priceLevels.sale.priceschedule || [];

      // Check if we have both price levels
      var hasBothPriceLevels =
        baseSchedule.length > 0 && saleSchedule.length > 0;

      // If we have both, create a combined schedule
      if (hasBothPriceLevels) {
        // Create a map of quantities to make matching easier
        var quantityMap = {};

        // Add all base prices to the map
        _.each(baseSchedule, function (tier, index) {
          var qty = tier.minimumquantity;
          if (!quantityMap[qty]) {
            quantityMap[qty] = {
              minimumquantity: qty,
              maximumquantity: tier.maximumquantity,
              basePrice: tier.price,
              base_price_formatted: "$" + (tier.price * qty).toFixed(2),
              hasSalePrice: false,
            };
          }
        });

        // Add all sale prices to the map
        _.each(saleSchedule, function (tier, index) {
          var qty = tier.minimumquantity;
          if (quantityMap[qty]) {
            // Update existing entry with sale price
            quantityMap[qty].price = tier.price;
            quantityMap[qty].price_formatted =
              "$" + (tier.price * qty).toFixed(2);
            quantityMap[qty].hasSalePrice = true;

            // Calculate discount percentage
            if (quantityMap[qty].basePrice > 0) {
              var discount =
                ((quantityMap[qty].basePrice - tier.price) /
                  quantityMap[qty].basePrice) *
                100;
              quantityMap[qty].discountPercentage = Math.round(discount);
            }
          } else {
            // Create new entry with only sale price
            quantityMap[qty] = {
              minimumquantity: qty,
              maximumquantity: tier.maximumquantity,
              price: tier.price,
              price_formatted: "$" + (tier.price * qty).toFixed(2),
              hasSalePrice: false,
            };
          }
        });

        // Apply freight indicators and format display text
        _.each(quantityMap, function (tier, qty) {
          // Calculate maximum quantity based on next tier
          var allQuantities = _.keys(quantityMap)
            .map(function (q) {
              return parseInt(q, 10);
            })
            .sort(function (a, b) {
              return a - b;
            });
          var currentIndex = allQuantities.indexOf(tier.minimumquantity);
          if (currentIndex < allQuantities.length - 1) {
            tier.maximumquantity = allQuantities[currentIndex + 1] - 1;
          }

          // Try to match index with freight indicator fields
          var tierIndex = _.findIndex(baseSchedule, function (baseTier) {
            return baseTier.minimumquantity === tier.minimumquantity;
          });

          if (tierIndex >= 0) {
            var freightValue = self.item.get(
              "custitem_bags_freight" + (tierIndex + 1)
            );
            if (freightValue) {
              tier.hasFreight = true;

              if (tier.hasSalePrice) {
                // tier.price_formatted += ' (+FRT)'; //new commented code
                tier.base_price_formatted += " (+FRT)";
              } else {
                tier.price_formatted += " (+FRT)";
              }
            }
          }

          // Create display text for dropdown
          if (tier.hasSalePrice) {
            tier.display_text =
              tier.minimumquantity +
              " - Price: " +
              tier.price_formatted +
              " (was " +
              tier.base_price_formatted +
              ")";
          } else {
            tier.display_text =
              tier.minimumquantity + " - Price: " + tier.price_formatted;
          }
        });

        // Convert map back to array and sort by quantity
        combinedSchedule = _.map(quantityMap, function (item) {
          return item;
        });

        combinedSchedule = _.sortBy(combinedSchedule, "minimumquantity");
      } else {
        // If only one price level exists, use it
        var activeSchedule =
          baseSchedule.length > 0 ? baseSchedule : saleSchedule;
        var isBasePriceActive = baseSchedule.length > 0;

        combinedSchedule = _.map(activeSchedule, function (tier, index) {
          var result = {
            minimumquantity: tier.minimumquantity,
            maximumquantity: tier.maximumquantity,
            hasSalePrice: false,
          };

          // Calculate maximum quantity for this tier
          if (index < activeSchedule.length - 1) {
            result.maximumquantity =
              activeSchedule[index + 1].minimumquantity - 1;
          }

          if (isBasePriceActive) {
            result.basePrice = tier.price;
            result.price = tier.price;
          } else {
            result.price = tier.price;
          }

          // Apply freight indicators
          var freightValue = self.item.get(
            "custitem_bags_freight" + (index + 1)
          );
          result.hasFreight = !!freightValue;

          // Format prices
          result.price_formatted =
            "$" + (tier.price * tier.minimumquantity).toFixed(2);
          if (freightValue) {
            result.price_formatted += " (+FRT)";
          }

          // Create display text for dropdown (no "was" text since only one price level)
          result.display_text =
            result.minimumquantity + " - Price: " + result.price_formatted;

          return result;
        });
      }

      return combinedSchedule;
    },
    optionBindEventByType: {
      select: "change",
      text: "blur",
      date: "change",
    },

    bindModel: function bindModel() {
      this.generateViewBindings();
      BackboneFormView.add(this, {
        noCloneModel: true,
      });
      var self = this;
      // Here we wrap the areAttributesValid method of the transaction line so when child views or injected views validate the model using this method
      // this view is notified and can show the error messages.
      // This is thanks to the poor "API" Backbone.validation offer.
      this.model.areAttributesValid = _.wrap(
        this.model.areAttributesValid,
        function (fn, attributes, validators) {
          var are_attr_valid = fn.apply(self.model, [attributes, validators]);
          var current_validation = _.extend({}, self.model.validation);
          let attribute_validation_result;

          _.extend(self.model.validation, validators);

          // In order to properly show the validation on message in the UI we need to validate against the temporal properties on the model
          // that are those binded to the template! (See method generateViewBindings)
          if (~_.indexOf(attributes, "options")) {
            self.model.get("options").map(function (option) {
              attributes.push(option.get("cartOptionId"));
            });
          }

          _.each(attributes, function (attribute) {
            attribute_validation_result = self.model.preValidate(
              attribute,
              self.model.get(attribute)
            );

            if (attribute_validation_result) {
              // Here we assume that the default selector 'name' is being used
              BackboneExtras.Validation.callbacks.invalid(
                self,
                attribute,
                attribute_validation_result,
                "name"
              );
            } else {
              BackboneExtras.Validation.callbacks.valid(
                self,
                attribute,
                "name"
              );
            }
          });

          self.model.validation = current_validation;

          return are_attr_valid;
        }
      );
    },

    generateViewBindings: function generateViewBindings() {
      var self = this;
      var option_bindings = self.model
        .get("options")
        .reduce(function (bindings, option) {
          var cart_option_id = option.get("cartOptionId");

          // Bind to set options
          bindings[`[name="${cart_option_id}"]`] = {
            observe: option.get("cartOptionId"), // << TEMP PROPERTY TO MAKE EASY VALIDATION (READ HERE)
            setOptions: {
              validate: true,
              silent: true,
            },
            onSet: function (value, options) {
              var { view } = options;
              var product_model = view.model;
              var option = product_model
                .get("options")
                .findWhere({ cartOptionId: options.observe });
              var current_value =
                option.get("value") && option.get("value").internalid;

              if (
                !option.get("isMandatory") &&
                current_value === value &&
                view.$(options.selector).attr("type") === "radio"
              ) {
                // unset value.
                value = null;
              }

              product_model.setOption(options.observe, value);

              return value;
            },
            events: [self.getBindingEventForOption(option)],
          };

          // Binding for the label (selected value)
          bindings[`[data-value="${cart_option_id}"]`] = {
            observe: option.get("cartOptionId"),
            onGet: function () {
              return option.get("value") ? option.get("value").label : "";
            },
          };

          _.each(option.get("values"), function (value) {
            if (value.internalid) {
              // Exclude the " - Select -" option
              // Bind for mute and active options
              bindings[
                `[data-label="label-${cart_option_id}"][value="${value.internalid}"]`
              ] = {
                attributes: [
                  {
                    name: "class",
                    observe: option.get("cartOptionId"),
                    onGet: function () {
                      var optionResult = _.findWhere(option.get("values"), {
                        internalid: value.internalid,
                      });
                      var isAvailable = !optionResult.isAvailable;
                      if (isAvailable) {
                        return "muted";
                      }
                      if (
                        value.internalid ===
                        (option.get("value") && option.get("value").internalid)
                      ) {
                        return "active";
                      }
                      return "";
                    },
                  },
                ],
              };
            }
          });

          return bindings;
        }, {});

      _.extend(this.bindings, option_bindings);
    },

    getBindingEventForOption: function getBindingEventForOption(option) {
      return (
        this.optionBindEventByType[option.get("type").toLowerCase()] || "blur"
      );
    },

    events: {
      'change [data-action="qty-pricing-change"]': "changeQtyPricing",
      'click [data-action="show-confirmation"]': "showConfirmationModal"    
    },
    
    showConfirmationModal: function (e) {
      e.preventDefault();
      this.model.set("combinedPriceSchedule", this.combinedPriceSchedule);
      var confirmationView = new DCConfirmationView({
        // item: (this.context === 'PLP') ? this.contextData.item() : this.item,
        item: this.item,
        selectedIndex: this.selectedIndex,
        container: this.container,
        model: this.model,
        // hasRequiredFields: hasRequiredFields
      });
      this.model.validate();
      if (this.model.isValid()) {
        this.container
          .getComponent("Layout")
          .showContent(confirmationView, { showInModal: true });
      }
    },
    // getSelectedPrice: function () {
    //   var priceSchedule =
    //     this.model &&
    //     this.model.get("item") &&
    //     this.model.get("item").get("onlinecustomerprice_detail")
    //       ? this.model.get("item").get("onlinecustomerprice_detail")
    //           .priceschedule
    //       : [];

    //   var self = this;
    //   _.map(priceSchedule, function (price, index) {
    //     var freightMessage = self.model
    //       .get("item")
    //       .get("custitem_bags_freight" + (index + 1))
    //       ? " (+FRT)"
    //       : ""; //as index starts from 0
    //     price.price_formatted =
    //       "$" +
    //       (price.price * price.minimumquantity).toFixed(2) +
    //       freightMessage;
    //     return price;
    //   });

    //   if (priceSchedule) {
    //     console.log(
    //       "priceSchedule[this.selectedIndex]",
    //       priceSchedule[this.model.get("selectedIndex")]
    //     );
    //     return priceSchedule[this.selectedIndex];
    //   }
    //   return {};
    // },
    getSelectedPrice: function () {
        console.log("=== getSelectedPrice DEBUG ===");
        console.log("this.selectedIndex:", this.selectedIndex);
        console.log("combinedPriceSchedule:", this.combinedPriceSchedule);
        console.log("tier at selectedIndex:", this.combinedPriceSchedule ? this.combinedPriceSchedule[this.selectedIndex] : "NO SCHEDULE");
        
        if (this.combinedPriceSchedule && this.combinedPriceSchedule[this.selectedIndex]) {
            var tier = this.combinedPriceSchedule[this.selectedIndex];
            console.log("returning tier quantity:", tier.minimumquantity);
            console.log("=== END getSelectedPrice ===");
            return tier;
        }
        console.log("returning empty object");
        console.log("=== END getSelectedPrice ===");
        return {};
    },

    childViews: {
      //   'Product.Options': function() {
      // 	return new ProductDetailsOptionsSelectorView({
      // 		model: this.model,
      // 		application: this.application,
      // 		show_pusher: this.showOptionsPusher(),
      // 		show_required_label: this.model ? this.model.get('item').get('itemtype') === 'GiftCert': false
      // 	});
      //   },

      AddToCart: function () {
        console.log("=== QtyPriceView AddToCart FIRED ===");
        var selectedPrice = this.getSelectedPrice();

        console.log("=== AddToCart childView DEBUG ===");
        console.log("selectedPrice:", selectedPrice);
        console.log("selectedPrice.minimumquantity:", selectedPrice.minimumquantity);
        console.log("this.model current quantity:", this.model.get("quantity"));

        var product = new ProductModel({
          item: this.model.getItem(),
          quantity: selectedPrice.minimumquantity,
        });

        this.model.set("quantity", selectedPrice.minimumquantity);
        product.set("options", this.model.get("options"));
        product.set("hasFreight", selectedPrice.hasFreight || false);

        console.log("NEW product quantity:", product.get("quantity"));
        console.log("=== END AddToCart childView ===");

        return new CartAddToCartButtonView({
          // model: this.item.get('_matrixChilds').length > 0 ? this.item : product,
          model: product,
          application: this.container,
          showButton: true,
        });
      },
      "ItemDetails.Options": function () {
        console.log("=== ItemDetails.Options DEBUG ===");
        console.log("context:", this.context);
        console.log("showLink:", this.context !== "PDQ");

        var options_configuration = Configuration.get(
          "ItemOptions.optionsConfiguration",
          []
        );
        return new BackboneCollectionView({
          collection: _.filter(
            this.model.get("options").sortBy("index"),
            function (option) {
              var option_configuration = _.findWhere(options_configuration, {
                cartOptionId: option.get("cartOptionId"),
              });
              return (
                option_configuration && option_configuration.showSelectorInList
              );
            }
          ),
          childView: ProductViewsOptionView,
          viewsPerRow: 1,
          childViewOptions: {
            item: this.model,
            templateName: "facetCell",
            showLink: self.context !== "PDQ",
            hideLabel: true,
            showSmall: true,
          },
        });
      },
    },

    showOptionsPusher: function showOptionsPusher() {
      return false;
    },

    changeQtyPricing: function (e) {
      // this.selectedIndex = this.$(e.currentTarget).val();
      // this.model.set('selectedIndex', this.$(e.currentTarget).val());
      // this.render();

      this.selectedIndex = this.$(e.currentTarget).val();
      this.model.set("selectedIndex", this.$(e.currentTarget).val());

      // Update model quantity based on selected tier
      var selectedTier = this.combinedPriceSchedule[this.selectedIndex];

      console.log("=== changeQtyPricing DEBUG ===");
      console.log("selectedIndex:", this.selectedIndex);
      console.log("selectedTier:", selectedTier);
      console.log("selectedTier.minimumquantity:", selectedTier ? selectedTier.minimumquantity : "N/A");
      console.log("model quantity BEFORE set:", this.model.get("quantity"));

      if (selectedTier && selectedTier.minimumquantity) {
        this.model.set("quantity", selectedTier.minimumquantity);
      }

      console.log("model quantity AFTER set:", this.model.get("quantity"));
      console.log("=== END changeQtyPricing ===");

      this.render();

      console.log("=== AFTER RENDER ===");
      console.log("quantity input value:", this.$('[name="quantity"]').val());
    },

    //@method getContext @return DC.QuantityPricing.QtyPrice.View.Context
    getContext: function getContext() {
      // this.item = (this.context === 'PLP') ? this.contextData.item() : this.item;

      // this.item = this.item;
      // console.log('Item in getContext', this.item);
      // // console.log('this.item.get(onlinecustomerprice_detail)', this.item.get('onlinecustomerprice_detail'));
      // this.priceSchedule = this.item.get('onlinecustomerprice_detail').priceschedule;
      // var priceToDisplay = '';
      // var unitPrice = '';
      // var self = this;
      // var selectedIndexNumber = parseInt(this.selectedIndex);

      // if(this.priceSchedule && this.priceSchedule.length){
      // 	unitPrice = '$'+(this.priceSchedule[this.selectedIndex].price).toFixed(4);
      // 	priceToDisplay = '$'+(this.priceSchedule[this.selectedIndex].minimumquantity * this.priceSchedule[this.selectedIndex].price).toFixed(2);

      //     //Freight message on Calculated Price
      //     // var freightValue = (self.item['custitem_bags_freight'+ (selectedIndexNumber+1)]);

      //     var freightValue = (this.item.get('custitem_bags_freight' + (selectedIndexNumber+1)));

      // 	console.log('Freight message on Calculated Price', freightValue);
      //     priceToDisplay = freightValue ? priceToDisplay+' (+FRT)': priceToDisplay;
      // 	console.log('Price to display: ', priceToDisplay);
      //     this.showPriceToDisplay = true;
      // }

      // if(this.context === 'PLP'){
      // 	this.showPriceToDisplay = false;
      // }

      // _.map(this.priceSchedule, function(price, index){
      // 	var freightMessage = (self.item.get('custitem_bags_freight'+ (index+1))) ? ' (+FRT)' : ''; //as index starts from 0
      // 	price.price_formatted = '$' + (price.price * price.minimumquantity).toFixed(2) + freightMessage;
      // 	return price;
      // })
      this.item = this.item;
      console.log("Item in getContext", this.item);
      // console.log('this.item.get(onlinecustomerprice_detail)', this.item.get('onlinecustomerprice_detail'));
      this.priceSchedule = this.item.get(
        "onlinecustomerprice_detail"
      )?.priceschedule;

      // Get the active tier
      var activeTier = null;
      if (
        this.combinedPriceSchedule &&
        this.combinedPriceSchedule[this.selectedIndex]
      ) {
        activeTier = this.combinedPriceSchedule[this.selectedIndex];
      }

      console.log("getContext: Active Tier: ", activeTier);
      // Determine if we have both price levels and sale is active
      var hasBothPriceLevels =
        this.priceLevels &&
        this.priceLevels.base.priceschedule.length > 0 &&
        this.priceLevels.sale.priceschedule.length > 0;

      console.log("getContext: hasBothPriceLevels", hasBothPriceLevels);

      var isSaleActive =
        hasBothPriceLevels && activeTier && activeTier.hasSalePrice;
      console.log("getContext: isSaleActive", isSaleActive);

      // Prepare display values
      var priceToDisplay = "";
      var unitPrice = "";
      var basePriceToDisplay = "";
      var baseUnitPrice = "";
      var discountPercentage = 0;

      if (activeTier) {
        // Sale price (or only price if no sale)
        if (activeTier.price) {
          unitPrice = "$" + activeTier.price.toFixed(4);
          priceToDisplay =
            "$" + (activeTier.price * activeTier.minimumquantity).toFixed(2);

          // Add freight indicator if applicable
          if (activeTier.hasFreight) {
            priceToDisplay += " (+FRT)";
          }

          // Add "was" price if sale price exists
          if (activeTier.hasSalePrice && activeTier.basePrice) {
            var basePriceForDisplay =
              "$" +
              (activeTier.basePrice * activeTier.minimumquantity).toFixed(2);
            if (activeTier.hasFreight) {
              basePriceForDisplay += " (+FRT)";
            }

            if (priceToDisplay.indexOf(" (+FRT)") !== -1) {
              priceToDisplay = priceToDisplay.replace(" (+FRT)", "");
            }

            priceToDisplay += " (was " + basePriceForDisplay + ")";
          }

          console.log(
            "getContext: If Sale price is active tier: ",
            priceToDisplay
          );
        }

        // Base price (if sale exists)
        if (activeTier.hasSalePrice && activeTier.basePrice) {
          baseUnitPrice = "$" + activeTier.basePrice.toFixed(4);
          basePriceToDisplay =
            "$" +
            (activeTier.basePrice * activeTier.minimumquantity).toFixed(2);

          // Add freight indicator if applicable
          if (activeTier.hasFreight) {
            basePriceToDisplay += " (+FRT)";
          }

          // Calculate discount percentage
          if (activeTier.discountPercentage) {
            discountPercentage = activeTier.discountPercentage;
          }

          console.log("getContext: basePriceToDisplay: ", basePriceToDisplay);
          console.log("getContext: discountPercentage: ", discountPercentage);
        }
      }

      this.showPriceToDisplay = !!priceToDisplay;

      if (this.context === "PLP") {
        this.showPriceToDisplay = false;
      }

      var hasMandatoryOptions = false;
      var optionsDetails = this.item.get("itemoptions_detail");
      if (optionsDetails && optionsDetails.fields) {
          hasMandatoryOptions = _.some(optionsDetails.fields, function(field) {
              return field.ismandatory === true;
          });
      }



      return {
        // hasQtyPricing: !!(this.priceSchedule && this.priceSchedule.length),
        // priceSchedule: this.priceSchedule,
        // showPriceToDisplay: this.showPriceToDisplay,
        // priceToDisplay: priceToDisplay,
        // unitPrice: unitPrice,
        // selectedIndex: this.selectedIndex,
        // ispdp :(this.context === 'PDP') ? true :false
        // // isplp :(this.context === 'PLP') ? true :false

        hasQtyPricing: !!(
          this.combinedPriceSchedule && this.combinedPriceSchedule.length
        ),
        combinedPriceSchedule: this.combinedPriceSchedule,
        showPriceToDisplay: this.showPriceToDisplay,
        priceToDisplay: priceToDisplay,
        unitPrice: unitPrice,
        selectedIndex: this.selectedIndex,
        ispdp: this.context === "PDP" ? true : false,
        // isplp: (this.context === 'PLP') ? true : false,

        // New properties for displaying both prices
        basePriceToDisplay: basePriceToDisplay,
        baseUnitPrice: baseUnitPrice,
        isSaleActive: isSaleActive,
        discountPercentage: discountPercentage,
        hasMandatoryOptions: hasMandatoryOptions && this.context === "PLP",
        itemUrl: this.item.get("_url"),
      };
    },
  });
});
